const UserDashboardStyles = {
    container: {
      padding: '2rem',
    },
    title: {
      marginBottom: '2rem',
    },
    overviewCard: {
      padding: '1rem',
      textAlign: 'center',
    },
    scheduledViewingsSection: {
      marginTop: '3rem',
    },
    sectionTitle: {
      marginBottom: '1rem',
    },
    listingItem: {
      marginBottom: '1rem',
    },
    savedListingsSection: {
      marginTop: '3rem',
    },
    accountSettingsSection: {
      marginTop: '3rem',
    },
    listItem: {
      border: '1px solid #ddd',
      borderRadius: '8px',
      padding: '1rem',
      marginBottom: '1rem',
      backgroundColor: '#fff',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
      '&:hover': {
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)',
      },
    },
  };
  
  export default UserDashboardStyles;
  